export default {
    name: 'yuri-timeline-comment',

    props: {
        item: null
    },

    /**
     * @override
     */
    data() {
        return {
            expanded: false
        };
    },

    methods: {
        /**
         * @override
         */
        download(uuidIssues, documentFile) {
            this.$issuesService.getDocument(uuidIssues, documentFile.uuid)
                .then(res => {
                    const urlCreator = window.URL || window.webkitURL;
                    this.filePreview = urlCreator.createObjectURL(res);
                    this.fileType = res.type;
                    this.fileName = documentFile.title;

                    const fileLink = document.createElement('a');
                    fileLink.href = this.filePreview;
                    fileLink.setAttribute('download', this.fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                });
        },

        /**
         * Gets User Initials
         * @param {Object} user Detalles del usuario
         * @return {String} User initials
         */
        getUserInitials(user) {
            const abbr = `${user.given_name.substring(0, 1)}${user.family_name_1.substring(0, 1)}`;
            return abbr;
        }
    }
};
